import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { getVendorName } from "../../../utils/getVendorName";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useFetchAllSBHistoryForBorosilMutation, useUpdateSBHistoryStatusMutation } from "../../../features/tenant/Borosil/SalesBoosterHistoryBorosilApi";
import toast from "react-hot-toast";
import { formatter } from "../../../utils/numberFormatter";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { showConfirmationToast } from "../../../utils/confirmationToast";

const SalesBoosterHistoryBorosil = () => {
  const [
    fetchAllSalesBoosterHistoryBorosil,
    {
      data: salesBoosterData,
      isLoading: salesBoosterIsLoading,
      error: salesBoosterError,
    },
  ] = useFetchAllSBHistoryForBorosilMutation();

  const [
    updateSBHistoryStatus,
    { isLoading: updateStatusIsLoading }
  ] = useUpdateSBHistoryStatusMutation();


  const [
    fetchAllSalesBoosterHistoryBorosilCsv,
    {
      data: salesBoosterDataCsv,
      isLoading: salesBoosterIsLoadingCsv,
      error: salesBoosterErrorCsv,
    },
  ] = useFetchAllSBHistoryForBorosilMutation();

  const navigate = useNavigate();
  const location = useLocation();


  const [totalRows, setTotalRows] = useState(0);
  const [data, setData] = useState([])


  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [csvData, setCsvData] = useState(null);
  const [isConfirmingOrUpdating, setIsConfirmingOrUpdating] = useState(false);

  const initialRequest = {
    name: "",
    limit: 10,
    offset: 0,
    mobile: ""
  };
  const [request, setRequest] = useState(initialRequest);

  const clearFilters = () => {
    setRequest(initialRequest);
  };

  const fetchAllSBHistoryFunc = () => {

    const newRequest = request;

    newRequest["sb_id"] = location?.state.id;

    fetchAllSalesBoosterHistoryBorosil({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: newRequest
    });
  }


  const fetchAllSBHistoryCsvFunc = () => {

    const newRequest = request;

    newRequest["sb_id"] = location?.state.id;
    newRequest["limit"] = 100000;
    newRequest["offset"] = 0

    fetchAllSalesBoosterHistoryBorosilCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: newRequest
    });
  }

  useEffect(() => {
    // if (JSON.parse(sessionStorage.getItem("vendorData")).tenant_id != 38) {
    //   navigate(`/genefied/${getVendorName()}/`);

    // }
    if (request.name === "" && request.mobile == "") {
      fetchAllSBHistoryFunc();
    }
  }, [request, limit, offset]);


  useEffect(() => {
    if (salesBoosterData && salesBoosterData.body) {
      console.log("sb history data", salesBoosterData);
      setData(salesBoosterData.body.data);
      setTotalRows(salesBoosterData.body.total)
    }

    if (salesBoosterError) {
      toast.error("Something went wrong", { id: "salesBoosterError" })
      console.log("sb history error ", salesBoosterError);
    }
  }, [salesBoosterData, salesBoosterError]);


  useEffect(() => {
    if (salesBoosterDataCsv && salesBoosterDataCsv.body) {
      console.log("sb history data", salesBoosterDataCsv);
      setCsvData(salesBoosterDataCsv.body.data);
    }

    if (salesBoosterErrorCsv) {
      toast.error("Something went wrong", { id: "salesBoosterErrorCsv" })
      console.log("sb history error ", salesBoosterErrorCsv);
      setCsvData([]);

    }
  }, [salesBoosterDataCsv, salesBoosterErrorCsv]);
  const handleUpdateStatus = async (row) => {
    if (isConfirmingOrUpdating) return;
    setIsConfirmingOrUpdating(true);

    try {
      const confirmed = await showConfirmationToast(
        `Are you sure you want to accept this sales booster record for ${row.name || "this user"}?`,
        {
          confirmText: "Yes, Accept",
          cancelText: "Cancel",
          confirmColor: "bg-green-600 hover:bg-green-700 text-white",
          cancelColor: "bg-gray-100 hover:bg-gray-200 text-gray-800",
          position: "top-center"
        }
      );

      if (!confirmed) {
        setIsConfirmingOrUpdating(false);
        return;
      }

      const toastId = toast.loading("Updating status...");
      try {
        const response = await updateSBHistoryStatus({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          body: {
            history_id: row.history_id || row.id,
            status: "2",
          },
        }).unwrap();

        if (response && response.status === 200) {
          toast.success("Status updated to Accepted successfully!", { id: toastId });
          fetchAllSBHistoryFunc(); // Refresh list data
        } else {
          toast.error(response?.message || "Failed to update status", { id: toastId });
        }
      } catch (err) {
        console.error("Error updating sales booster status:", err);
        toast.error(err?.data?.message || err?.message || "Something went wrong while updating status", { id: toastId });
      }
    } finally {
      setIsConfirmingOrUpdating(false);
    }
  };

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Mobile",
      selector: (row) => row.mobile,
      sortable: true,
      width: "120px",
    },
    {
      name: "User ID",
      selector: (row) => row.user_id,
      sortable: true,
      width: "150px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "220px",
    },
    {
      name: "User Purchase Value",
      selector: (row) => formatter.format(row.user_value),
      sortable: true,
      width: "220px",
    },
    {
      name: "Value",
      selector: (row) => formatter.format(row.trigger_value),
      sortable: true,
      width: "220px",
    },
    {
      name: "City",
      selector: (row) => row.city,
      sortable: true,
      width: "220px",
    },
    {
      name: "District",
      selector: (row) => row.district,
      sortable: true,
      width: "220px",
    },
    {
      name: "State",
      selector: (row) => row.state,
      sortable: true,
      width: "220px",
    },
    {
      name: "Zone",
      selector: (row) => row.zone_name,
      sortable: true,
      width: "220px",
    },
    {
      name: "Trigger Status",
      cell: (row) => {
        const isAccepted = row.trigger_status == "2" || row.trigger_status == 2;
        return (
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${isAccepted
              ? "bg-green-100 text-green-800"
              : "bg-yellow-100 text-yellow-800"
              }`}
          >
            {isAccepted ? "Accepted" : "Pending"}
          </span>
        );
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Action",
      cell: (row) => {
        const isAccepted = row.trigger_status == "2" || row.trigger_status == 2;
        return (
          <button
            disabled={isAccepted || updateStatusIsLoading || isConfirmingOrUpdating}
            onClick={() => handleUpdateStatus(row)}
            className={`px-3 py-1 rounded text-xs font-semibold transition-all duration-150 ${isAccepted
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-indigo-600 text-white hover:bg-indigo-700 active:bg-indigo-800 shadow-sm"
              }`}
          >
            {isAccepted ? "Accepted" : "Accept"}
          </button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    },
  ];



  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
  };
  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            History
            <LinksComponent />
          </div>
          <div className="p-3">

            <div className="mb-2">
              <CustomExport
                fetchData={fetchAllSBHistoryCsvFunc}
                data={csvData}
                defaultColumnExport={[
                  "mobile",
                  "remarks",
                ]}
                filename={`${location?.state?.name}_History`}
              />
            </div>
            <div className="border-b border-gray-300 bg-sky-50 rounded-t-md px-2 py-1">
              <div className="flex max-w-xl justify-between gap-2">
                <h4>
                  <span className="text-gray-400 text-sm  block">
                    Scheme Name :
                  </span>
                  <span className="flex text-black text-sm  gap-1">
                    {location.state.name}
                  </span>
                </h4>

                <h4>
                  <span className="text-gray-400 text-sm  block">
                    Start Date
                  </span>
                  <span className="flex text-black text-sm  gap-1">
                    {location.state.start_date}
                  </span>
                </h4>
                <h4>
                  <span className="text-gray-400 text-sm  block">
                    End Date :
                  </span>
                  <span className="flex text-black text-sm  gap-1 ">
                    {location.state.end_date}
                  </span>
                </h4>
              </div>


            </div>

            <div className="p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                // title={"Product List"}
                data={data}
                loading={salesBoosterIsLoading}
                totalRows={totalRows}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              >
                <div className="border-b pb-3 border-gray-300 bg-gray-50 rounded-t-lg">
                  <div className="flex  space-x-2 justify-end">
                    <div className="w-52 h-10 ">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Mobile
                        </label>
                        <input
                          type="search"
                          id="default-search"
                          className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="Mobile..."
                          required
                          value={request.mobile}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return { ...prevState, mobile: newValue };
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="w-52 h-10 ">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Name
                        </label>
                        <input
                          type="search"
                          id="default-search"
                          className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="Name..."
                          required
                          value={request.name}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return { ...prevState, name: newValue };
                            });
                          }}
                        />
                      </div>
                    </div>


                    <div className="flex flex-row  gap-2 h-10">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          &nbsp;
                        </label>
                        <button
                          className="btn btn-outline-primary clear-both float-right  p-2"
                          onClick={() => {
                            fetchAllSBHistoryFunc();
                          }}
                        >
                          Search
                        </button>
                      </div>
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          &nbsp;
                        </label>
                        <button
                          className="btn btn-outline-primary clear-both float-right p-2"
                          onClick={() => {
                            clearFilters();
                          }}
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </DataTableComponent>

            </div>



          </div>
        </div>
      </div>
    </>
  );
};

export default SalesBoosterHistoryBorosil;
